import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from 'src/app/core/services/http/http.service';
import { EndPoints } from 'src/app/shared/EndPoints';
import { NpiDialogDto } from 'src/app/core/classes/npi-dialog-dto';

@Injectable({
  providedIn: 'root'
})
export class PhysicianService {
  CPPortalBaseUrl: any;
  isNpiDialog: boolean;

  constructor(private httpService: HttpService) {
    this.CPPortalBaseUrl = environment.customerPortalServiceUrl;
  }

  get npiDialogStatus(): boolean {
    return this.isNpiDialog;
  }

  set npiDialogStatus(param: boolean) {
    this.isNpiDialog = param;
  }

  getPhysicianList(request: NpiDialogDto): any {
    return this.httpService.Post(
      this.CPPortalBaseUrl + EndPoints.physicianDetailsFromRegistry,
      request
    );
  }

}
